import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

const authHeaders = (token) => ({
  Authorization: `Bearer ${token || null || ""}`,
});

export async function fetchBusinessSettings(token) {
  const res = await axios.get(`${API}/admin/business`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function updateBusinessSettings(data, token) {
  const res = await axios.patch(`${API}/admin/business`, data, {
    headers: {
      ...authHeaders(token),
      "Content-Type": "application/json",
    },
  });
  return res.data;
}

export async function listBusinessUsers(token) {
  const res = await axios.get(`${API}/admin/business/users`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function addBusinessUser(payload, token) {
  const res = await axios.post(`${API}/admin/business/users`, payload, {
    headers: {
      ...authHeaders(token),
      "Content-Type": "application/json",
    },
  });
  return res.data;
}

export async function removeBusinessUser(userId, token) {
  await axios.delete(`${API}/admin/business/users/${userId}`, {
    headers: authHeaders(token),
  });
}

export async function listBusinessSalons(token) {
  const res = await axios.get(`${API}/admin/business/salons`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function attachSalonToBusiness(payload, token) {
  const res = await axios.post(`${API}/admin/business/salons`, payload, {
    headers: {
      ...authHeaders(token),
      "Content-Type": "application/json",
    },
  });
  return res.data;
}

export async function getBusinessMergePreview(payload, token) {
  const res = await axios.get(`${API}/admin/business/merge/preview`, {
    params: {
      source_business_id: payload?.source_business_id,
      target_business_id: payload?.target_business_id,
      mode: payload?.mode,
    },
    headers: authHeaders(token),
  });
  return res.data;
}

export async function mergeBusinesses(payload, token) {
  const res = await axios.post(`${API}/admin/business/merge`, payload, {
    headers: {
      ...authHeaders(token),
      "Content-Type": "application/json",
    },
  });
  return res.data;
}

export async function detachSalonFromBusiness(salonId, token) {
  const res = await axios.delete(`${API}/admin/business/salons/${salonId}`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function repairSalonBusinessLinks(salonId, payload, token) {
  const res = await axios.post(
    `${API}/admin/business/salons/${salonId}/repair-links`,
    payload,
    {
      headers: {
        ...authHeaders(token),
        "Content-Type": "application/json",
      },
    }
  );
  return res.data;
}
